import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },

  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },


  {
    path: 'categoria-form',
    loadChildren: () => import('./pages/categorias/categoria-form/categoria-form.module').then( m => m.CategoriaFormPageModule)
  },
  {
    path: 'categoria-editar/:id',
    loadChildren: () => import('./pages/categorias/categoria-form/categoria-form.module').then( m => m.CategoriaFormPageModule)
  },
  {
    path: 'categoria-list',
    loadChildren: () => import('./pages/categorias/categoria-list/categoria-list.module').then( m => m.CategoriaListPageModule)
  },



  {
    path: 'cliente-list',
    loadChildren: () => import('./pages/cliente/cliente-list/cliente-list.module').then( m => m.ClienteListPageModule)
  },
  {
    path: 'cliente-editar/:id',
    loadChildren: () => import('./pages/cliente/cliente-form/cliente-form.module').then( m => m.ClienteFormPageModule)
  },
  {
    path: 'cliente-form',
    loadChildren: () => import('./pages/cliente/cliente-form/cliente-form.module').then( m => m.ClienteFormPageModule)
  },





  {
    path: 'opcionais-form',
    loadChildren: () => import('./pages/opcionais/opcionais-form/opcionais-form.module').then( m => m.OpcionaisFormPageModule)
  },
  {
    path: 'opcionais-editar/:id',
    loadChildren: () => import('./pages/opcionais/opcionais-form/opcionais-form.module').then( m => m.OpcionaisFormPageModule)
  },
  {
    path: 'opcionais-list',
    loadChildren: () => import('./pages/opcionais/opcionais-list/opcionais-list.module').then( m => m.OpcionaisListPageModule)
  },
  {
    path: 'opcionais-list2',
    loadChildren: () => import('./pages/opcionais/opcionais-list2/opcionais-list2.module').then( m => m.OpcionaisList2PageModule)
  },




  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },



  {
    path: 'opcional-produto-list',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/opcional_produto/opcional-produto-list/opcional-produto-list.module').then( m => m.OpcionalProdutoListPageModule)
  },
  {
    path: 'opcional-produto-form',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/opcional_produto/opcional-produto-form/opcional-produto-form.module').then( m => m.OpcionalProdutoFormPageModule)
  },










  {
    path: 'produto-list2/:id',
    loadChildren: () => import('./pages/produtos/produto-list2/produto-list2.module').then( m => m.ProdutoList2PageModule)
  },
  {
    path: 'produto-preco-form',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/produto-preco/produto-preco-form/produto-preco-form.module').then( m => m.ProdutoPrecoFormPageModule)
  },
  {
    path: 'produto-preco-list/:id',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/produto-preco/produto-preco-list/produto-preco-list.module').then( m => m.ProdutoPrecoListPageModule)
  },
  {
    path: 'produto-list/:id',
    loadChildren: () => import('./pages/produtos/produto-list/produto-list.module').then( m => m.ProdutoListPageModule)
  },
  {
    path: 'produto-form',
    loadChildren: () => import('./pages/produtos/produto-form/produto-form.module').then( m => m.ProdutoFormPageModule)
  },
  {
    path: 'produto-editar/:id',
    loadChildren: () => import('./pages/produtos/produto-form/produto-form.module').then( m => m.ProdutoFormPageModule)
  },



  {
    path: 'categoria-selecao-form-ativo',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/categoria-selecao-form-ativo/categoria-selecao-form-ativo.module').then( m => m.CategoriaSelecaoFormAtivoPageModule)
  },
  {
    path: 'categoria-selecao-form-preco',
    // tslint:disable-next-line: max-line-length
    loadChildren: () => import('./pages/categoria-selecao-form-preco/categoria-selecao-form-preco.module').then( m => m.CategoriaSelecaoFormPrecoPageModule)
  },
  {
    path: 'categoria-selecao-form',
    loadChildren: () => import('./pages/categoria-selecao-form/categoria-selecao-form.module').then( m => m.CategoriaSelecaoFormPageModule)
  },





  {
    path: 'frete-list-ativo',
    loadChildren: () => import('./pages/fretes/frete-list-ativo/frete-list-ativo.module').then( m => m.FreteListAtivoPageModule)
  },
  {
    path: 'frete-list-preco',
    loadChildren: () => import('./pages/fretes/frete-list-preco/frete-list-preco.module').then( m => m.FreteListPrecoPageModule)
  },
  {
    path: 'fretes-list2',
    loadChildren: () => import('./pages/fretes/fretes-list2/fretes-list2.module').then( m => m.FretesList2PageModule)
  },





  {
    path: 'opcionalgrupo',
    loadChildren: () => import('./pages/opcionalgrupo/opcionalgrupo.module').then( m => m.OpcionalgrupoPageModule)
  },



  {
    path: 'pedido-list/:tipo',
    loadChildren: () => import('./pages/pedido/pedido-list/pedido-list.module').then( m => m.PedidoListPageModule)
  },
  {
    path: 'pedido-selecionado2/:id/:tipo',
    loadChildren: () => import('./pages/pedido/pedido-selecionado2/pedido-selecionado2.module').then( m => m.PedidoSelecionado2PageModule)
  },
  {
    path: 'selecao-tipo-pedido',
    loadChildren: () => import('./pages/pedido/selecao-tipo-pedido/selecao-tipo-pedido.module').then( m => m.SelecaoTipoPedidoPageModule)
  },

  
  {
    path: 'gerenciar-pedidos/:tipo',
    loadChildren: () => import('./pages/pedido/gerenciar-pedidos/gerenciar-pedidos.module').then( m => m.GerenciarPedidosPageModule)
  },


  {
    path: 'selecao-tipo-pedido-gerenciar',
    loadChildren: () => import('./pages/pedido/selecao-tipo-pedido-gerenciar/selecao-tipo-pedido-gerenciar.module').then( m => m.SelecaoTipoPedidoGerenciarPageModule)
  },


  {
    path: 'pedido-selecionado-gerenciar/:id/:tipo',
    loadChildren: () => import('./pages/pedido/pedido-selecionado-gerenciar/pedido-selecionado-gerenciar.module').then( m => m.PedidoSelecionadoGerenciarPageModule)
  },
  {
    path: 'configuracoes-front',
    loadChildren: () => import('./pages/configuracoes-front/configuracoes-front.module').then( m => m.ConfiguracoesFrontPageModule)
  },
  {
    path: 'esqueceu-senha',
    loadChildren: () => import('./pages/esqueceu-senha/esqueceu-senha.module').then( m => m.EsqueceuSenhaPageModule)
  },
  {
    path: 'ordenar-categoria',
    loadChildren: () => import('./pages/ordenar-categoria/ordenar-categoria.module').then( m => m.OrdenarCategoriaPageModule)
  },
  {
    path: 'ordenar-produtos/:id',
    loadChildren: () => import('./pages/ordenar-produtos/ordenar-produtos.module').then( m => m.OrdenarProdutosPageModule)
  },
  {
    path: 'selecao-categoria',
    loadChildren: () => import('./pages/selecao-categoria/selecao-categoria.module').then( m => m.SelecaoCategoriaPageModule)
  },
  {
    path: 'relatorio/:tipo',
    loadChildren: () => import('./pages/relatorio/relatorio.module').then( m => m.RelatorioPageModule)
  },
  {
    path: 'estatistica',
    loadChildren: () => import('./pages/estatistica/estatistica.module').then( m => m.EstatisticaPageModule)
  },
  {
    path: 'teste-report',
    loadChildren: () => import('./pages/teste-report/teste-report.module').then( m => m.TesteReportPageModule)
  },
  {
    path: 'selecao-relatorio',
    loadChildren: () => import('./pages/selecao-relatorio/selecao-relatorio.module').then( m => m.SelecaoRelatorioPageModule)
  },
  {
    path: 'gerar-relatorios/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/gerar-relatorio/gerar-relatorio.module').then( m => m.GerarRelatorioPageModule)
  },
  {
    path: 'gerar-ranking/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/gerar-ranking/gerar-ranking.module').then( m => m.GerarRankingPageModule)
  },
  {
    path: 'gerar-relatorio-produtos/:data/:data2/:status/:tipo',
    loadChildren: () => import('./pages/gerar-relatorio-produtos/gerar-relatorio-produtos.module').then( m => m.GerarRelatorioProdutosPageModule)
  },
  



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
